/* Lecteur d'extrait « Feuilleter le livre » (Tome 1). JavaScript pur, aucune dépendance. Les pages sont des IMAGES (le texte du livre n'est ni copiable ni indexé).
   Déclencheur : tout élément [data-reader-open] (lien : href = 1re page, utilisé sans JavaScript). Ouverture directe : ?extrait=1 ou #feuilleter (MiReader.autoOpen()).
   Données : window.MI_READER_DATA (objet ou fonction, maquette : js/livre.js) ou <script type="application/json" id="mi-reader-data"> (thème : snippet mi-extrait-reader).
     { ratio (hauteur / largeur d'une page, 1.5 par défaut ; 1.294 = Letter, ebook Business Planner), pages:[{src, thumb, alt}], labels:{ title, note, close, prev, next, zoom_in, zoom_out, page, pages, fin, thumbs, thumb, fin_titre, fin_texte, voir_debut, ajouter },
       end:{ price, variant, available } }   (labels.page = « Page {n} / {total} », labels.pages = « Pages {a}-{b} / {total} », labels.thumb = « Page {n} »)
   Même fichier dans la maquette (js/extrait-reader.js) et le thème (assets/mi-extrait-reader.js, copié par tools/make_extrait_reader_t1.py --sync-reader). */
(() => {
  if (window.MiReader) return;
  const DESK = window.matchMedia('(min-width: 1024px)');
  const RATIO = 1.5;                       // hauteur / largeur d'une page par défaut (data.ratio le remplace : S.ratio)
  const ZOOM = 2.2;
  const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const fmt = (s, v) => String(s ?? '').replace(/\{(\w+)\}|%(\w+)%/g, (m, a, b) => { const k = a || b; return v && v[k] != null ? v[k] : m; });   // {n} (maquette) ou %n% (thème : les accolades gênent Liquid)
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ICO = {
    prev: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7"/></svg>',
    next: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7"/></svg>',
    close: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    zin: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="11" cy="11" r="6.500"/><path d="M16 16l4.500 4.500M11 8.500v5M8.500 11h5"/></svg>',
    zout: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="11" cy="11" r="6.500"/><path d="M16 16l4.500 4.500M8.500 11h5"/></svg>',
  };

  function getData() {
    let d = window.MI_READER_DATA;
    if (typeof d === 'function') { try { d = d(); } catch (e) { d = null; } }
    if (!d) { try { d = JSON.parse(document.getElementById('mi-reader-data')?.textContent || 'null'); } catch (e) { d = null; } }
    return d && Array.isArray(d.pages) && d.pages.length ? d : null;
  }

  let S = null;   // état de la session ouverte

  function spreadsFor(n) {
    const out = [[0]];
    if (DESK.matches) { for (let i = 1; i < n; i += 2) out.push(i + 1 < n ? [i, i + 1] : [i]); }
    else { for (let i = 1; i < n; i++) out.push([i]); }
    return out;
  }

  function build(data, opener) {
    const L = data.labels || {};
    const ratio = +data.ratio > 0 ? +data.ratio : RATIO;
    const d = document.createElement('dialog');
    d.className = 'rd'; d.setAttribute('aria-label', L.title || '');
    if (ratio !== RATIO) d.style.setProperty('--rd-ratio', ratio);
    d.innerHTML = `
<div class="rd__bar">
  <p class="rd__count" aria-live="polite" data-rd-count></p>
  <div class="rd__tools">
    <button class="rd__btn" type="button" data-rd-zoom aria-pressed="false" aria-label="${esc(L.zoom_in)}">${ICO.zin}</button>
    <button class="rd__btn" type="button" data-rd-close aria-label="${esc(L.close)}">${ICO.close}</button>
  </div>
</div>
<div class="rd__stage">
  <button class="rd__nav rd__nav--prev" type="button" data-rd-prev aria-label="${esc(L.prev)}">${ICO.prev}</button>
  <div class="rd__view" data-rd-view tabindex="-1">
    <div class="rd__sheet" data-rd-sheet></div>
    <div class="rd__end" data-rd-end hidden>
      <h2 class="rd__end-t">${esc(L.fin_titre)}</h2>
      <p class="rd__end-p">${esc(L.fin_texte)}</p>
      ${data.end && data.end.price ? `<p class="rd__end-price">${esc(data.end.price)}</p>` : ''}
      <div class="rd__end-row">
        ${data.end && data.end.variant && data.end.available !== false ? `<button class="btn" type="button" data-add-to-cart="${esc(data.end.variant)}" data-rd-add>${esc(L.ajouter)}</button>` : ''}
        <button class="rd__link" type="button" data-rd-restart>${esc(L.voir_debut)}</button>
      </div>
    </div>
  </div>
  <button class="rd__nav rd__nav--next" type="button" data-rd-next aria-label="${esc(L.next)}">${ICO.next}</button>
</div>
${L.note ? '<div class="rd__foot"><p class="rd__note">' + esc(L.note) + '</p>' : ''}<nav class="rd__thumbs" aria-label="${esc(L.thumbs)}"><ul>${data.pages.map((p, i) => `<li><button type="button" data-rd-thumb="${i}" aria-label="${esc(fmt(L.thumb, { n: i + 1 }))}"><img src="${esc(p.thumb || p.src)}" alt="" width="160" height="${Math.round(160 * ratio)}" loading="lazy" decoding="async"></button></li>`).join('')}</ul></nav>${L.note ? '</div>' : ''}`;
    document.body.appendChild(d);
    return d;
  }

  function open(opener, start) {
    const data = getData(); if (!data || S) return false;
    const dlg = build(data, opener);
    S = { data, dlg, opener, ratio: +data.ratio > 0 ? +data.ratio : RATIO, spreads: [], step: 0, zoom: false, tx: 0, ty: 0, pw: 0 };
    const q = (s) => dlg.querySelector(s);
    Object.assign(S, { sheet: q('[data-rd-sheet]'), view: q('[data-rd-view]'), end: q('[data-rd-end]'), count: q('[data-rd-count]'), zbtn: q('[data-rd-zoom]'), prevB: q('[data-rd-prev]'), nextB: q('[data-rd-next]') });
    S.imgs = {};
    layout(start || 0, false);
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    document.body.classList.add('no-scroll');
    fit();
    q('[data-rd-close]').focus();
    bind();
    return true;
  }

  function close() {
    if (!S) return;
    const { dlg } = S;
    if (dlg.open && typeof dlg.close === 'function') dlg.close(); else cleanup();
  }
  function cleanup() {
    if (!S) return;
    const s = S; S = null;
    s.ro && s.ro.disconnect();
    DESK.removeEventListener('change', s.onMq);
    s.dlg.remove();
    document.body.classList.remove('no-scroll');
    if (s.opener && s.opener.focus) {
      // clic / toucher : pas d'anneau de focus (évite un double contour autour du bouton) ; clavier : anneau normal
      if (s.viaKey) { s.opener.removeAttribute('data-rd-ptr'); s.opener.focus(); }
      else { s.opener.setAttribute('data-rd-ptr', ''); try { s.opener.focus({ focusVisible: false }); } catch (e) { s.opener.focus(); } s.opener.addEventListener('blur', () => s.opener.removeAttribute('data-rd-ptr'), { once: true }); }
    }
  }

  /* spreads recalculés (changement de largeur) en gardant la page courante */
  function layout(pageIdx, animate) {
    const n = S.data.pages.length;
    S.spreads = spreadsFor(n);
    const i = S.spreads.findIndex((sp) => sp.includes(Math.min(pageIdx, n - 1)));
    go(i < 0 ? 0 : i, animate ? 0 : null);
  }

  function pageImg(i) {
    const p = S.data.pages[i];
    return `<figure class="rd__page${i === 0 ? ' rd__page--cover' : ''}"><img src="${esc(p.src)}" alt="${esc(p.alt)}" decoding="async" draggable="false"></figure>`;
  }
  function preload(step) {
    const sp = S.spreads[step]; if (!sp) return;
    sp.forEach((i) => { if (!S.imgs[i]) { const im = new Image(); im.src = S.data.pages[i].src; S.imgs[i] = im; } });
  }

  function go(step, dir) {
    if (!S) return;
    const last = S.spreads.length;               // index de l'écran de fin
    step = Math.max(0, Math.min(last, step));
    const prevStep = S.step; S.step = step;
    resetZoom();
    const isEnd = step === last;
    S.end.hidden = !isEnd; S.sheet.hidden = isEnd;
    S.zbtn.disabled = isEnd;
    if (!isEnd) {
      const sp = S.spreads[step];
      S.sheet.innerHTML = sp.map(pageImg).join('');
      S.sheet.dataset.n = sp.length;
      preload(step + 1); preload(step - 1);
    } else {
      S.sheet.innerHTML = '';
    }
    S.prevB.disabled = step === 0; S.nextB.disabled = isEnd;
    if (S.dlg.open && (!document.activeElement || document.activeElement === document.body || !S.dlg.contains(document.activeElement) || document.activeElement.disabled)) S.view.focus({ preventScroll: true });   // un bouton devenu inactif perd le focus : le clavier reste dans le lecteur
    // compteur
    const total = S.data.pages.length, L = S.data.labels || {};
    if (isEnd) S.count.textContent = L.fin || '';
    else { const sp = S.spreads[step]; S.count.textContent = sp.length === 1 ? fmt(L.page, { n: sp[0] + 1, total }) : fmt(L.pages, { a: sp[0] + 1, b: sp[1] + 1, total }); }
    // miniatures
    const on = isEnd ? [] : S.spreads[step];
    S.dlg.querySelectorAll('[data-rd-thumb]').forEach((b) => {
      const act = on.includes(+b.dataset.rdThumb); b.classList.toggle('is-on', act);
      if (act) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
    });
    const cur = S.dlg.querySelector('[data-rd-thumb].is-on') || S.dlg.querySelector(`[data-rd-thumb="${total - 1}"]`);
    const strip = S.dlg.querySelector('.rd__thumbs ul');
    if (cur && strip && S.dlg.open) { const li = cur.parentElement; strip.scrollTo({ left: li.offsetLeft - (strip.clientWidth - li.offsetWidth) / 2, behavior: reduce() ? 'auto' : 'smooth' }); }   // défile la bande seule (scrollIntoView ferait glisser la boîte entière)
    fit();
    if (dir !== null && dir !== undefined && S.dlg.open && !reduce() && step !== prevStep) {
      const target = isEnd ? S.end : S.sheet, sgn = step > prevStep ? 1 : -1;
      target.animate([{ opacity: 0, transform: `translateX(${sgn * 28}px)` }, { opacity: 1, transform: 'none' }], { duration: 260, easing: 'cubic-bezier(.22,.8,.3,1)' });
    }
  }

  /* taille des pages : la plus grande qui tient dans la zone visible */
  function fit() {
    if (!S) return;
    const r = S.view.getBoundingClientRect(); if (!r.width) return;
    const n = S.spreads[S.step] ? S.spreads[S.step].length : 1;
    const ph = Math.min(r.height, (r.width / n) * S.ratio);
    S.sheet.style.setProperty('--rd-ph', Math.floor(ph) + 'px');
    S.sheet.style.setProperty('--rd-pw', Math.floor(ph / S.ratio) + 'px');
    applyZoom();
  }

  /* zoom : transform seul, déplacement limité aux bords de la page */
  function clamp() {
    const w = S.sheet.offsetWidth, h = S.sheet.offsetHeight;
    const mx = (w * (ZOOM - 1)) / 2, my = (h * (ZOOM - 1)) / 2;
    S.tx = Math.max(-mx, Math.min(mx, S.tx)); S.ty = Math.max(-my, Math.min(my, S.ty));
  }
  function applyZoom() {
    if (!S) return;
    if (S.zoom) { clamp(); S.sheet.style.transform = `translate(${S.tx}px, ${S.ty}px) scale(${ZOOM})`; }
    else S.sheet.style.transform = '';
    S.view.classList.toggle('is-zoom', S.zoom);
  }
  function setZoom(on, px, py) {
    if (!S || S.end.hidden === false) return;
    const L = S.data.labels || {};
    if (on && !S.zoom) {
      const r = S.sheet.getBoundingClientRect(); const cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      S.tx = px == null ? 0 : (1 - ZOOM) * (px - cx); S.ty = py == null ? 0 : (1 - ZOOM) * (py - cy);
    }
    S.zoom = on;
    S.zbtn.setAttribute('aria-pressed', String(on));
    S.zbtn.setAttribute('aria-label', on ? L.zoom_out : L.zoom_in);
    S.zbtn.innerHTML = on ? ICO.zout : ICO.zin;
    S.sheet.classList.toggle('is-anim', !reduce());
    applyZoom();
  }
  function resetZoom() { if (S && S.zoom) { S.zoom = false; S.tx = S.ty = 0; const L = S.data.labels || {}; S.zbtn.setAttribute('aria-pressed', 'false'); S.zbtn.setAttribute('aria-label', L.zoom_in); S.zbtn.innerHTML = ICO.zin; applyZoom(); } }

  function bind() {
    const s = S, dlg = s.dlg;
    s.ro = new ResizeObserver(() => fit()); s.ro.observe(s.view);
    s.onMq = () => { if (!S) return; const sp = S.spreads[S.step]; layout(sp ? sp[0] : S.data.pages.length - 1, false); };
    DESK.addEventListener('change', s.onMq);
    dlg.addEventListener('close', cleanup);
    dlg.addEventListener('cancel', () => {});   // Échap : fermeture native, puis « close » rend le focus
    dlg.addEventListener('pointerdown', () => { s.viaKey = false; });
    dlg.addEventListener('click', (e) => {
      const t = e.target;
      if (t.closest('[data-rd-close]')) close();
      else if (t.closest('[data-rd-prev]')) go(S.step - 1, -1);
      else if (t.closest('[data-rd-next]')) go(S.step + 1, 1);
      else if (t.closest('[data-rd-zoom]')) setZoom(!S.zoom);
      else if (t.closest('[data-rd-restart]')) go(0, -1);
      else if (t.closest('[data-rd-add]')) setTimeout(close, 0);   // l'ajout au panier est traité par le script du panier ; on ferme ensuite pour laisser voir le tiroir
      else { const th = t.closest('[data-rd-thumb]'); if (th) { const i = +th.dataset.rdThumb; const st = S.spreads.findIndex((sp) => sp.includes(i)); go(st, st > S.step ? 1 : -1); } }
    });
    dlg.addEventListener('keydown', (e) => {
      s.viaKey = true;
      if (e.key === 'ArrowRight' || e.key === 'PageDown') { e.preventDefault(); go(S.step + 1, 1); }
      else if (e.key === 'ArrowLeft' || e.key === 'PageUp') { e.preventDefault(); go(S.step - 1, -1); }
      else if (e.key === 'Home' && !e.target.closest('input')) { e.preventDefault(); go(0, -1); }
      else if (e.key === 'End') { e.preventDefault(); go(S.spreads.length, 1); }
      else if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'Tab') {
        const f = [...dlg.querySelectorAll('button:not([disabled]), a[href]')].filter((el) => el.offsetParent !== null || el === document.activeElement);
        if (!f.length) return;
        const a = document.activeElement, first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (a === first || !dlg.contains(a))) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && (a === last || !dlg.contains(a))) { e.preventDefault(); first.focus(); }
      }
    });
    // balayage tactile / souris ; clic simple = zoom ; déplacement quand zoomé
    let p = null;
    s.view.addEventListener('pointerdown', (e) => {
      if (e.button > 0 || e.target.closest('button, a')) return;
      p = { id: e.pointerId, x: e.clientX, y: e.clientY, tx: S.tx, ty: S.ty, moved: false };
      try { s.view.setPointerCapture(e.pointerId); } catch (er) {}
    });
    s.view.addEventListener('pointermove', (e) => {
      if (!p || e.pointerId !== p.id) return;
      const dx = e.clientX - p.x, dy = e.clientY - p.y;
      if (Math.abs(dx) + Math.abs(dy) > 8) p.moved = true;
      if (S.zoom) { S.tx = p.tx + dx; S.ty = p.ty + dy; S.sheet.classList.remove('is-anim'); applyZoom(); }
    });
    const end = (e) => {
      if (!p || e.pointerId !== p.id) return;
      const dx = e.clientX - p.x, dy = e.clientY - p.y; const q = p; p = null;
      if (e.type === 'pointercancel') return;
      if (S.zoom) { if (!q.moved) setZoom(false); return; }
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.4) go(S.step + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
      else if (!q.moved && S.end.hidden) setZoom(true, e.clientX, e.clientY);
    };
    s.view.addEventListener('pointerup', end); s.view.addEventListener('pointercancel', end);
  }

  function autoOpen() {
    const q = new URLSearchParams(location.search);
    if (!(q.get('extrait') === '1' || location.hash === '#feuilleter')) return false;
    const opener = document.querySelector('[data-reader-open]');
    return open(opener || null, 0);
  }

  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-reader-open]'); if (!a) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    if (open(a, 0)) e.preventDefault();
  });
  window.MiReader = { open, close, autoOpen };
  const init = () => { if (getData()) autoOpen(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
